import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent } from '@app/shared/components';
import { PhotoInputComponent } from '@app/shared/components/photo-input/photo-input.component';
import { AppUtils } from '@app/shared/util/app.utils';

@Component({
    selector: 'app-task-photo-upload-modal',
    templateUrl: './task-photo-upload-modal.component.html',
    styleUrls: ['./task-photo-upload-modal.component.scss']
})
export class TaskPhotoUploadModalComponent implements OnInit {

    @ViewChild(ModalComponent, {static: false}) modal: ModalComponent;
    @ViewChild(PhotoInputComponent, {static: false}) fileInput: PhotoInputComponent;

    @Input() readonly = false;

    @Output() confirmEvent = new EventEmitter<any>();

    photos = [];

    showValidations = false;
    isConfirmationInProgress = false;

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        this.handlePhotosChanged(this.photos);
    }

    open(photos = null) {
        this.reset();
        this.modal.open();

        if (photos) {
            this.handlePhotosChanged(photos);
        }
    }

    close() {
        this.reset();
        this.modal.close();
        this.isConfirmationInProgress = false;
    }

    onCancel() {
        this.close();
    }

    onConfirm() {
        if (this.fileInput.uploadedImages.length === 0 && this.photos.length === 0) {
            this.showValidations = true;
            return;
        }

        this.isConfirmationInProgress = true;
        this.confirmEvent.emit({
            selectedImages: [...this.fileInput.uploadedImages, ...this.photos],
            carouselImages: this.photos
        });
        this.close();
    }

    private reset() {
        this.photos = [];
        this.showValidations = false;
    }

    onFilesChanged(event: any) {
        this.photos = this.photos.filter(photo => photo.id !== event.id);
    }

    handlePhotosChanged(photos) {
        this.photos = photos;
    }
}
